// @flow
import React from 'react';
import { intlShape } from 'react-intl';
import { Button, buttonTypes } from 'moods-react/Button';
import { TextInput } from 'moods-react/TextInput';
import Dialog from '../DialogComponent';
import messages from '../../../../data/approvals';

import '../DialogButtons.scss';

type Props = {
  thumbnailImageUrl: string,
  thumbnailAltText: string,
  title: string,
  description: string,
  buttonText: string,
  isReasonFieldEnabled: Boolean,
  actions: {
    closeOverlay: Function,
    approvalAction: Function,
  },
};

type Context = {
  intl: Object,
};

type Event = {
  target: {
    value: string,
  },
};

class ApprovalDialogComponent extends React.Component<Props, Context> {
  static contextTypes = {
    intl: intlShape.isRequired,
  };

  constructor() {
    super();
    this.state = {
      reason: '',
      isOverLimit: false,
    };
  }

  closeAndApprovalAction = () => {
    this.props.actions.closeOverlay();
    this.props.actions.approvalAction(this.state.reason);
  };

  handleReasonChange = (isOverLimit: boolean, e: Event) => {
    const { value } = e.target;
    this.setState({
      reason: value,
      isOverLimit,
    });
  };

  counterTextLimitMessage = (count: number) =>
    this.context.intl.formatMessage(messages.approveDialogReasonFieldCounterTextLimitMessage, { count });

  counterTextLimitExceededMessage = (overCount: number) =>
    this.context.intl.formatMessage(messages.approveDialogReasonFieldCounterTextLimitExceededMessage, { overCount });

  render() {
    const { thumbnailImageUrl, thumbnailAltText, title, description, buttonText, isReasonFieldEnabled } = this.props;

    const { formatMessage } = this.context.intl;

    return (
      <Dialog
        title={title}
        description={description}
        closeOverlay={this.props.actions.closeOverlay}
        thumbnailImageUrl={thumbnailImageUrl}
        thumbnailAltText={thumbnailAltText}
      >
        {isReasonFieldEnabled && (
          <TextInput.WithCounter
            data-approval-reason-field
            className="dialog-component__text-input"
            multiline
            placeholder={formatMessage(messages.approveDialogReasonFieldPlaceholder)}
            onChange={this.handleReasonChange}
            characterLimit={800}
            counterTextLimitMessage={this.counterTextLimitMessage}
            counterTextLimitExceededMessage={this.counterTextLimitExceededMessage}
          />
        )}
        <div className="dialog-component__buttons">
          <Button
            onClick={this.props.actions.closeOverlay}
            type={buttonTypes.STANDALONE_WHITE}
            data-approval-dialog-cancel
            className="dialog-button"
          >
            {formatMessage(messages.approvalDialogButtonCancel)}
          </Button>
          <Button
            isDisabled={this.state.isOverLimit}
            onClick={this.closeAndApprovalAction}
            data-approval-dialog-approval-button
            className="dialog-button"
          >
            {buttonText}
          </Button>
        </div>
      </Dialog>
    );
  }
}

ApprovalDialogComponent.displayName = 'ApprovalDialog';

export default ApprovalDialogComponent;
